import SignalTag from './SignalTag';

export default SignalTag;
